/*!
 * Stimpack Lightbox
 *
 * @package : stimpack
 * @version : 1.0
 */

import { spIsBase64, spBase64Decode } from '../utilities/utilities';

(function($){

    var spLightbox = function(el, options)
    {
        var _t = this,
            root = $(el);

        // Options

        this.o = $.extend({}, {}, options);

        // Elements
        this.el = {
            root : root
        };

        this.fb = this.el.root.fancybox(this.o);

        if (this.o.open)
        {
            this.fb.click();
        }

        return this;
    };

    $.fn.spLightbox = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-lightbox');

            $(this).attr('data-sp-lightbox', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spLightbox = new spLightbox(this, options);
        });
    };

    $('[data-sp-lightbox], .sp-lightbox').spLightbox();

    $('[data-sp-lightbox-auto], .sp-lightbox-auto').each(function () {

        var root = $(this),
            options = root.data('sp-lightbox-auto') || {};

        if (spIsBase64(options))
        {
            options = JSON.parse(spBase64Decode(options));
        }

        root.on('click', 'a:not([data-sp-lightbox])', function(e) {

            var trigger = $(this),
                href = trigger.attr('href');

            if (href && typeof trigger[0].spLightbox == 'undefined' && href.match(/(\.jpg|\.jpeg|\.png|\.gif|\.svg|youtu|vimeo|google\.com\/maps|instagram)$/))
            {
                e.preventDefault();
                options.open = true;
                trigger.spLightbox(options);
            }
        });
    });

})(jQuery);
